<template>
  <div>
    <!--  採番一覧選択画面 -->
    <t-card>
      <!-- 採番情報 -->
      <div class="searchConditionForm" :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          :label-width="$t('widgetSize.ACCEPT_ORDER_INFO.DIALOG_LABEL_WIDTH')"
        >
          <t-row>
            <!-- 得意先 -->
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))">
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.CUS_NAME')"
                class="marginBottom"
              >
                <t-select
                  v-model="searchConditionForm.searchCusCode"
                  class="commonDialog.el-select"
                  :placeholder="$t('resource.sys.hidden')"
                >
                  <t-option
                    v-for="item in cusCpyList"
                    :key="item.cusCode"
                    :label="item.cusCode + ':' + item.cusAbbreviation"
                    :value="item.cusCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 見積No -->
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))">
              <t-form-item
                :label="$t('resource.COMMON_CONSTANT.ESTIMATED_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchQuoteNo"
                  class="commonDialog"
                  maxlength="20"
                  :clearable="true"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 図番 -->
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))">
              <t-form-item
                :label="$t('resource.COMMON_CONSTANT.PICTURE_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchDrawNo"
                  class="commonDialog"
                  maxLength="30"
                  :clearable="true"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
              class="col_common_center"
            >
              <!-- <t-checkbox
                v-model="searchConditionForm.searchReaccept"
                style="line-height: 3"
                >{{ $t("resource.ACCEPT_ORDER.REACCEPT") }}</t-checkbox
              > -->
              <t-radio
                v-model="searchConditionForm.searchReaccept"
                label="1"
                style="line-height: 3"
                >{{ $t("resource.ACCEPT_ORDER.NOT_ACCEPT") }}</t-radio
              >
              <t-radio
                v-model="searchConditionForm.searchReaccept"
                label="2"
                style="line-height: 3"
                >{{ $t("resource.ACCEPT_ORDER.ACCEPTED") }}</t-radio
              >
            </t-col>

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              align="right"
            >
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                style="margin-top: 0"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.COMMON_CONSTANT.SEARCH") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col>
            <!-- テーブル -->
            <div>
              <t-table
                ref="numberSelectTableData"
                :data="numberSelectTableData"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                @row-click="handleRowClick"
                @row-dblclick="handleRowDblClick"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <!-- 確定ボタン -->
      <div align="right" :style="{ height: bottomHeight + 'px' }">
        <t-button
          round
          type="warning"
          class="dialogButton_confirm_120_40"
          ref="confirmBtn"
          :disabled="numberSelectTableData.length == 0"
          @click="confirmClick"
        >
          <i class="el-icon-check"></i>
          {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
        >
      </div>
    </t-card>
  </div>
</template>
<script>
import { ShowAcceptProductsDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { getAcceptableNumber, getCustomersList } from "@/services/acceptOrder";
import {
  formatDateStrToString,
  getAbleCusMstInfoList,
  getDialogContentHeight,
} from "@/utils/comFunction";
import {
  AOB_ACCEPT_STATE_NOT_ACCEPT_ORDERED,
  DIALOG_LINE_HEIGHT,
  STR_EMPTY,
} from "@/utils/const";
//import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //検索条件
      searchConditionForm: {
        searchCusCode: STR_EMPTY,
        searchQuoteNo: STR_EMPTY,
        searchReaccept: STR_EMPTY,
        searchDrawNo: STR_EMPTY,
      },

      //得意先リスト
      cusCpyList: [],

      //受注一覧選択情報
      numberSelectTableData: [],

      //仕入先見積依頼のテーブルの列
      columns: [
        // 見積No
        {
          prop: "nbQuoteNo",
          label: t("resource.COMMON_CONSTANT.ESTIMATED_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },
        // 見積日
        {
          prop: "nbQuoteDate",
          label: t("resource.NUMBER.QUOTE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 得意先
        {
          prop: "nbCusCodeAbb",
          label: t("resource.COMMON_CONSTANT.CUSTOMER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先担当者
        {
          prop: "mmMgrAbb",
          label: t("resource.ACCEPT_ORDER.CUS_USER_NAME"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },
        // // 得意先コード
        // {
        //   prop: "nbCusCode",
        //   label: t("resource.ACCEPT_ORDER.CUS_NAME"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   show: false,
        // },
        // // 得意先担当者コード
        // {
        //   prop: "nbCusUserCode",
        //   label: t("resource.ACCEPT_ORDER.CUS_USER_NAME"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        //   show: false,
        // },
      ],

      //現在選択されている行
      currentRow: null,

      data: null,
    };
  },

  props: {
    aobQuoteNo: {
      Type: Object,
    },
    btnKbn: {
      Type: Object,
    },
  },
  mounted() {
    this.init();

    //列幅に自動調整
    //setColumnWidth(this.numberSelectTableData);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    //确定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      if (this.currentRow) {
        let editData = [];
        ShowAcceptProductsDialog(
          {
            reacceptFlg:
              this.currentRow.reacceptFlg ===
              AOB_ACCEPT_STATE_NOT_ACCEPT_ORDERED
                ? false
                : true,
            aobQuoteNo: this.currentRow.nbQuoteNo,
            editTableData: editData,
          },
          t("resource.ACCEPT_ORDER.DIALOG_ACCEPT_PRODUCT_EDIT"),
          (target) => {
            if (!!target) {
              this.$emit("ok", target);
            } else {
              this.init;
            }
          }
        );
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //データの変換処理
    dataProcess() {
      this.numberSelectTableData.map((item) => {
        //受注日の変換
        //item.aobAcceptDate = formatDateStrToString(item.aobAcceptDate);

        //見積日の変換
        item.nbQuoteDate = formatDateStrToString(item.nbQuoteDate);

        //得意先納期の変換
        // item.aobCusDeliveryDate = formatDateStrToString(
        //   item.aobCusDeliveryDate
        // );

        return item;
      });
    },

    //行データのクリック処理
    handleRowClick(row) {
      this.currentRow = row;
    },

    //行データのダブルクリック処理
    handleRowDblClick(row) {
      this.currentRow = row;
      this.confirmClick();
    },

    // 初期化
    init() {
      //見積情報の初期化
      this.infoInit();

      //検索処理
      this.searchClick();

      //列幅に自動調整
      //setColumnWidth(this.numberSelectTableData);
    },

    //見積情報の初期化
    infoInit() {
      //再度受注ボタンを選択した時
      // if (this.btnKbn === "reaccept") {
      //   this.searchConditionForm.searchQuoteNo = this.aobQuoteNo;
      //   this.searchConditionForm.searchReaccept = "2";
      // } else {
      //   this.searchConditionForm.searchReaccept = "1";
      // }

      //未受注を選択する
      this.searchConditionForm.searchReaccept =
        AOB_ACCEPT_STATE_NOT_ACCEPT_ORDERED;

      //this.searchConditionForm.searchCusCode = this.selectItem.label;
      getCustomersList()
        .then((res) => {
          //得意先リスト
          this.cusCpyList = res.searchCusCode;
          this.getAbleList();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //使用可能な得意先リストの取得
    getAbleList() {
      // 得意先リスト
      this.cusCpyList = getAbleCusMstInfoList(
        this.cusCpyList,
        this.searchConditionForm.searchCusCode
      );
    },

    // 検索
    searchClick() {
      //検索条件の処理
      // let searchConditionFormTemp = {
      //   searchCusCode: this.searchConditionForm.searchCusCode,
      //   searchQuoteNo: this.searchConditionForm.searchQuoteNo,
      // };

      // getOrderableOrder(searchConditionFormTemp)
      //   .then((res) => {
      //     this.numberSelectTableData = res;

      //     console.log(
      //       "numberSelectTableData====>" +
      //         JSON.stringify(this.numberSelectTableData)
      //     );

      //     this.dataProcess();

      //     setColumnWidth(this.numberSelectTableData);
      //   })
      //   .catch((err) => {});

      this.searchConditionForm.searchQuoteNo =
        this.searchConditionForm.searchQuoteNo.trim();

      this.searchConditionForm.searchDrawNo =
        this.searchConditionForm.searchDrawNo.trim();

      //前に選択した行データを取り消す
      this.currentRow = null;

      //受注可能の採番情報の取得
      getAcceptableNumber(this.searchConditionForm)
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
          this.numberSelectTableData = res.acceptNumberList;

          // データ処理
          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });

      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
  },
};
</script>
<style scoped>
</style>
